export const tr = {
    'auto-overdraft-sum-interval':
        'Kapatma sınırının değeri geçersiz. Kapatma sınırı {minSum} {currency} ile {maxSum} {currency} arasında olmalıdır',
    'balance-unavailable-exception': 'Hata oluştu. Tekrar deneyin.',
    'bank-payment': 'Havaleyle',
    'cannot-be-null': 'Değeri girin',
    'card-payment': 'Banka kartı',
    'general-error': 'Hata oluştu. Tekrar deneyin.',
    'no-rights-for-edit-auto-overdraft': 'Kapatma sınırını düzenlemek için yetki yok',
    'no-rights-for-edit-wallet': 'Kapatma sınırını düzenlemek için yetki yok',
    'paypal-wallet-payment': 'PayPal',
    'too-big-payment':
        'Ödeme yöntemi olarak "{PaymentMethodName}" seçildiğinde devre dışı bırakma eşik tutarı {maxSum} {currency} değerinin altına düşemez.',
    'wallet-sum-must-be-not-null': "Hesapta kalan bakiye 0'dan fazla olmalıdır",
    'webmoney-wallet-payment': 'Webmoney (WMR)',
    'yamoney-wallet-payment': 'Yandex.Money',
    'ynd-fixed-currency-error': 'Seçilen cüzdanın para birimi için kapatma sınırı belirtilemez'
};
